<div class="container pt-5">
  <div class="px-4 text-center">
    <h1 style="color: var(--primary-color)" class="display-5 ">¿Tienes alguna <span class="fw-bold">pregunta?</span></h1>
    <h4 style="color: var(--primary-color)" class="  fs-3">Te respondemos algunas de las más frecuentes</h4>
  </div>
</div>


<div class="container mx-auto py-5  w-75">
  <div class="card p-1" *ngFor="let question of questions">
    <ul class="list-group list-group-flush">
      <a data-bs-toggle="collapse" href="#{{question.id}}" role="button" aria-expanded="false" aria-controls="collapseExample">
        <li class="list-group-item text-secondary"> <i style="color: var(--terciary-color)" class="bi bi-plus fw-bold"></i> {{question.pregunta}}</li>
      </a>
      <div class="collapse mx-auto" id="{{question.id}}">
        <div class="card card-body mx-4 p-3">
          <p class="text-secondary">{{question.respuesta}}</p>
        </div>
      </div>
    </ul>
  </div>
</div>


<app-info/>


<div class="contai">
  <app-our-clients/>
</div>



<app-footer-persona/>
